import React from 'react';
import ComparativeTable from '../components/erp/ComparativeTable';

const ComparativeTablePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="space-y-6">
        {/* Tabla Comparativa */}
        <ComparativeTable />
      </div>
    </div>
  );
};

export default ComparativeTablePage;
